module.exports = __webpack_public_path__ + "static/media/LI15.df0d08f8.jpg";